import { CoverOptions, PageDimensions, PageOptions } from './types'

export interface BookDefault {
  dimensions: PageDimensions
  cover: Pick<CoverOptions, 'fontSize'>
  page: Pick<PageOptions, 'fontSize'>
  entriesPerPage: number
}

const largeSquareBook: BookDefault = {
  dimensions: {
    height: 12,
    width: 12,
  },
  cover: {
    fontSize: 28,
  },
  page: {
    fontSize: 14,
  },
  entriesPerPage: 3,
}

const mediumSquareBook: BookDefault = {
  dimensions: {
    width: 10,
    height: 10,
  },
  cover: {
    fontSize: 24,
  },
  page: {
    fontSize: 14,
  },
  entriesPerPage: 2,
}

const smallSquareBook: BookDefault = {
  dimensions: {
    width: 8.5,
    height: 8.5,
  },
  cover: {
    fontSize: 24,
  },
  page: {
    fontSize: 12,
  },
  entriesPerPage: 2,
}

const largeRectangleBook: BookDefault = {
  dimensions: {
    width: 14,
    height: 11,
  },
  cover: {
    fontSize: 28,
  },
  page: {
    fontSize: 14,
  },
  entriesPerPage: 4,
}

const mediumRectangleBook: BookDefault = {
  dimensions: {
    width: 12.5,
    height: 10,
  },
  cover: {
    fontSize: 24,
  },
  page: {
    fontSize: 14,
  },
  entriesPerPage: 3,
}

const smallRectangleBook: BookDefault = {
  dimensions: {
    width: 11,
    height: 8.5,
  },
  cover: {
    fontSize: 24,
  },
  page: {
    fontSize: 12,
  },
  entriesPerPage: 2,
}

const xSmallRectangleBook: BookDefault = {
  dimensions: {
    width: 9,
    height: 7,
  },
  cover: {
    fontSize: 24,
  },
  page: {
    fontSize: 12,
  },
  entriesPerPage: 2,
}

export const bookFormats = {
  'large-square': largeSquareBook,
  'medium-square': mediumSquareBook,
  'small-square': smallSquareBook,
  'large-rectangle': largeRectangleBook,
  'medium-rectangle': mediumRectangleBook,
  'small-rectangle': smallRectangleBook,
  'xsmall-rectangle': xSmallRectangleBook,
}

export type BookSizes = keyof typeof bookFormats
